{
  "version": 1,
  "asset_id": "77311c9b-bcc7-411e-bf1d-c65c53f09726",
  "project_id": "5ebebed5-d757-4c4f-9e26-a06d6761c2a0",
  "url": "/__l5e/assets-v1/77311c9b-bcc7-411e-bf1d-c65c53f09726/igs-schreiner.png",
  "r2_key": "a/v1/5ebebed5-d757-4c4f-9e26-a06d6761c2a0/77311c9b-bcc7-411e-bf1d-c65c53f09726/igs-schreiner.png",
  "original_filename": "igs-schreiner.png",
  "size": 13650,
  "content_type": "image/png",
  "created_at": "2026-06-25T00:53:46Z"
}
